
import { useState } from 'react';
import { Link } from 'react-router-dom';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: "How long do I have access to the course?",
      answer: "You get lifetime access to the course materials. Once you purchase, you can access the content anytime, anywhere, and review it as many times as needed."
    },
    {
      question: "How long does it take to get my Georgia dealer license?",
      answer: "The typical timeline is 60-90 days from start to finish. This includes completing our course, gathering required documents, finding a location, and going through the state approval process."
    },
    {
      question: "What's the total cost to get my dealer license?",
      answer: "The total investment is typically $3,000-$5,000, which includes our course ($97), state fees, surety bond, insurance, location setup, and other required expenses. Our course shows you exactly what to budget for."
    },
    {
      question: "Do I need a physical location before applying?",
      answer: "Yes, you must have a physical business location secured before submitting your application to the Georgia Department of Revenue. Our course covers exactly what type of location qualifies and how to find one."
    },
    {
      question: "Can I download the course materials?",
      answer: "Some materials like templates and guides are downloadable, but the main video content is streamed through our secure platform to protect the intellectual property and ensure you always have the most up-to-date information."
    },
    {
      question: "Do I still need to attend the GIADA seminar?",
      answer: "Yes, the Georgia Independent Automobile Dealers Association (GIADA) seminar is still required by the state. However, our course prepares you thoroughly so you'll understand everything covered in the seminar."
    },
    {
      question: "How is this different from free information online?",
      answer: "Our course provides the complete, step-by-step system with current requirements, insider tips, and proven strategies. Free information is often outdated, incomplete, or incorrect, leading to costly mistakes and delays."
    },
    {
      question: "How many modules are in the course?",
      answer: "The course contains 10 comprehensive modules covering every aspect of getting your Georgia dealer license, from initial planning to final approval and beyond."
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Get answers to common questions about our Georgia Dealer License Course
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200">
              <button
                className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition-colors"
                onClick={() => toggleFAQ(index)}
              >
                <span className="font-medium text-gray-900 pr-4">{faq.question}</span>
                <span className="flex-shrink-0">
                  {openIndex === index ? (
                    <i className="ri-subtract-line text-xl text-teal-600"></i>
                  ) : (
                    <i className="ri-add-line text-xl text-teal-600"></i>
                  )}
                </span>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-6">
            Still have questions? We're here to help!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/consulting"
              className="inline-flex items-center justify-center px-6 py-3 bg-teal-600 text-white font-medium rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap"
            >
              <i className="ri-chat-3-line mr-2"></i>
              Chat with Us Now
            </Link>
            <Link
              to="/faq"
              className="inline-flex items-center justify-center px-6 py-3 bg-white text-teal-600 font-medium rounded-lg border-2 border-teal-600 hover:bg-teal-50 transition-colors whitespace-nowrap"
            >
              View All FAQs
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
